module.exports = __webpack_public_path__ + "img/logo-lalibertad.e27b6435.png";